import { render, staticRenderFns } from "./fiduciary-bancolombia.vue?vue&type=template&id=1f98423b"
import script from "./fiduciary-bancolombia.vue?vue&type=script&lang=js"
export * from "./fiduciary-bancolombia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports